import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs, Button } from "antd";
import isEqual from "lodash.isequal";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import restaurantSchemaActions from "../../../redux/restaurantSchema/actions";
import reservationsActions from "../../../redux/reservations/actions";
import ReservationsTableViewsComponent from "../../../components/User/ReservationComponent/ReservationTableViewComponent/ReservationsTableViewsComponent";
import DatePickerComponent from "./DatePickerComponent";
import "./index.css";

const { getRegions } = restaurantSchemaActions;
const { getTablesAndReservationPerRegion, getReservationsPerRegion } =
  reservationsActions;

const ReservationsTableView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState();
  const [showOrHideColumns, setShowOrHideColumns] = useState(false);
  const [date, setDate] = useState(dayjs());
  const [items, setItems] = useState([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const { regions } = useSelector((state) => state.restaurantSchemaReducer);

  useEffect(() => {
    dispatch(getRegions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isEqual(items, regions) && regions[0]?.key) {
      setActiveKey(regions[0]?.key);
      setItems(regions);
      // Get all Reservations
      dispatch(
        getReservationsPerRegion({
          organizationId: parseInt(localStorage.getItem("organizationId")),
          regionId: regions[0]?.key,
          date: date.format("YYYY-MM-DD"),
        })
      );
      dispatch(
        getTablesAndReservationPerRegion({
          organizationId: parseInt(localStorage.getItem("organizationId")),
          regionId: regions[0]?.key,
          date: date.format("YYYY-MM-DD"),
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regions]);

  useEffect(() => {
    // Make new request to get RESERVATIONS only when we change the date
    if (regions[0]?.key) {
      dispatch(
        getTablesAndReservationPerRegion({
          organizationId: parseInt(localStorage.getItem("organizationId")),
          regionId: regions[0]?.key,
          date: date.format("YYYY-MM-DD"),
        })
      );
      // Get all Reservations
      dispatch(
        getReservationsPerRegion({
          organizationId: parseInt(localStorage.getItem("organizationId")),
          regionId: regions[0]?.key,
          date: date.format("YYYY-MM-DD"),
        })
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onChange = (newActiveKey) => {
    setActiveKey(newActiveKey);
    // Get all Reservation Tables
    dispatch(
      getTablesAndReservationPerRegion({
        organizationId: parseInt(localStorage.getItem("organizationId")),
        regionId: newActiveKey,
        date: date.format("YYYY-MM-DD"),
      })
    );
    // Get all Reservations
    dispatch(
      getReservationsPerRegion({
        organizationId: parseInt(localStorage.getItem("organizationId")),
        regionId: newActiveKey,
        date: date.format("YYYY-MM-DD"),
      })
    );
  };

  // Replace the old children with new one
  items.forEach((item) => {
    item.children = (
      <ReservationsTableViewsComponent
        regionId={activeKey}
        date={date}
        showOrHideColumns={showOrHideColumns}
        setShowOrHideColumns={setShowOrHideColumns}
      />
    );
  });

  return (
    <>
      {screenWidth < 768 && (
        <>
          <DatePickerComponent date={date} setDate={setDate} />
          {date.isSame(dayjs(), "day") && dayjs().format("HH") >= 12 && (
            <Button
              id="reservation-view-show-hide-columns-mobile-btn"
              onClick={() => setShowOrHideColumns(!showOrHideColumns)}
            >
              {showOrHideColumns === false
                ? `Скрий до ${dayjs().subtract(1, "hour").format("HH")} часа`
                : "Покажи"}
            </Button>
          )}
          <Button
            id="reservation-view-show-hide-columns-mobile-btn"
            onClick={() => navigate("/reservation")}
          >
            Карта на Резервациите
          </Button>
        </>
      )}
      <Tabs
        tabBarExtraContent={
          screenWidth >= 768 && (
            <div className="reservation-view-tab-container">
              <Button onClick={() => navigate("/reservation")}>
                Карта на Резервациите
              </Button>
              {date.isSame(dayjs(), "day") && dayjs().format("HH") >= 12 && (
                <Button
                  onClick={() => setShowOrHideColumns(!showOrHideColumns)}
                >
                  {showOrHideColumns === false
                    ? `Скрий до ${dayjs()
                        .subtract(1, "hour")
                        .format("HH")} часа`
                    : "Покажи"}
                </Button>
              )}

              <DatePickerComponent date={date} setDate={setDate} />
            </div>
          )
        }
        onChange={onChange}
        type="card"
        activeKey={activeKey}
        items={items}
      />
    </>
  );
};
export default ReservationsTableView;
